export interface Plan {
  interval: PlanFrequency;
  price: number;
  stripeId: string;
}

export type PlanName = "Small" | "Medium" | "Large";

export interface SubscriptionType {
  id: PlanUniqueId;
  image?: string;
  name: PlanName;
  plans: Plan[];
}

export enum PlanUniqueId {
  discontinuedDoubleDiamond = "O4iA4NwOLOZrnMJtccGa",
  individualBootBag = "GLfXsXKG8ZwM3ggoWYfx",
  individualLargeSuitcase = "e7ezbPL5DtZwOEtJBAqZ",
  large = "REuK9bJWeclFMBJteUHD",
  medium = "MXgdu3M7bMyzhGHKxGtt",
  small = "PF3mVyztGVrDvOUVYLTK",
}

export enum PlanFrequency {
  annual = "annual",
  monthly = "monthly",
}
